import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import getTheme from './themes';

export const AuthThemeContext = React.createContext(
    {
        currentTheme: 'vas',
        setAppTheme: null
    },
);

const AuthThemeProvider = (props) => {
    const { children } = props;
    const currentTheme = localStorage.getItem('theme');
    const [appTheme, setAppTheme] = useState(currentTheme);
    const theme = getTheme(appTheme);

    const _setAppTheme = (appTheme) => {
        localStorage.setItem('theme', appTheme);
        setAppTheme(appTheme);
    };

    const contextValue = {
        currentTheme: appTheme,
        setAppTheme: _setAppTheme
    }

    return (
        <AuthThemeContext.Provider value={contextValue}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </AuthThemeContext.Provider>
    );
}

export default AuthThemeProvider